module.exports = __webpack_public_path__ + "static/media/2DGACM4.0a7366a4.jpg";